<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="transform: scaleY(-1)"
  >
    <path
      d="M2.8 0.999995L2.8 29.8167C2.8 31.1359 2.8 31.7955 3.16697 32.2793C3.53393 32.7631 4.16812 32.9396 5.43648 33.2927L18.0365 36.8001C18.5153 36.9334 18.7546 37 19 37C19.2454 37 19.4847 36.9334 19.9635 36.8001L32.5635 33.2927C33.8319 32.9396 34.4661 32.7631 34.833 32.2793C35.2 31.7955 35.2 31.1359 35.2 29.8167L35.2 0.999995"
      :stroke="color"
      stroke-width="2.5"
    />
    <path
      d="M1 1L37 1"
      :stroke="color"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M2.8 24.4L18.2191 27.9121C18.7334 28.0293 19.2666 28.0293 19.781 27.9121L35.2 24.4"
      :stroke="color"
      stroke-width="2.5"
    />
    <path
      d="M32.77 17.74L35.2 17.2M25.48 19.36L27.1 19M20.62 20.44L19 20.8L17.38 20.44M5.23 17.74L2.8 17.2M12.52 19.36L10.9 19"
      :stroke="color"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path d="M19 28L19 1" :stroke="color" stroke-width="2.5" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
